import {TimeOffRequest} from 'main/stores/time_off';
import {endpoints, types} from 'main/tools';
import { action, computed, observable } from 'mobx';
import {t} from 'shared/core';
import {DomainStore} from 'shared/store';
import {successAlert} from 'shared/tools';

class RequestDetailsState {
  store = new DomainStore();
  history;
  
  @observable match;
  @observable request;

  receiveProps({history, match}) {
    this.history = history;
    this.match = match;    
  }

  @action async load() {
    try {
      await this.store._compose([
        `${endpoints.TIME_OFF.REQUEST.with(this.match.params.id)},assignments,assignments.delegated_by_user`
      ]);
  
      this.request = new TimeOffRequest(this.store._getSingle(
        types.TIME_OFF.REQUEST, { id: this.match.params.id }
      ));
    } catch (e) {
      successAlert(t('time_off.requests.Request is no longer available.'));
      this.history.push('/pending_requests');
    }
  }

  @action onBackClick() {
    window.location = this.backButtonDetails.backPath;
  }

  @computed get backButtonDetails() {
    const {backPath} = this.match.params;

    if (backPath === 'employee') {
      return {
        backPath: `/employees/${this.request.employee.id}/time-off`,
        backTitle: this.request.employee.name
      };
    } else {
      return {
        backPath: '/time_off/pending_requests',
        backTitle: t('time_off.requests.Pending Requests')
      };
    }
  }
}

export default RequestDetailsState;